import React from "react";
import {
  Page,
  MacProfiList,
  BreadCrumbs,
  RepairAppleLinksBanner,
  Section,
  RepairAppleLinksText,
  SelectForIphoneServiceLinks,
  RepairAppleTextWithCheckMark,
  RepairIpadModelLinks,
  RepairIpadServiceLinks,
} from "../index";
import banner from "../../images/banners/repair-ipadSpeaker.jpeg";
import { Helmet } from "react-helmet";

const listOfTrouble = [
  {
    id: 1,
    text: "Наиболее удачный вариант - засор защитной сетки, попадание пыли или других загрязнений. В таком случае, замена динамика на айпаде даже и не потребуется - проблему решит элементарная чистка.",
    number: "01",
  },
  {
    id: 2,
    text: "Попадание различного типа влаги, которое приводит к окислению контактов. Влага может проникнуть как извне в виде воды, различных чаёв, кофе и т.п., так и образоваться внутри в виде конденсата. Если жидкости на динамики попало относительно немного, к тому же она была неагрессивной, есть небольшой шанс, что динамики можно будет восстановить. Во всех других случаях замена динамиков iPad неизбежна.",
    number: "02",
  },
  {
    id: 3,
    text: 'Различные механические повреждения. Т.к. динамики iPad напрямую прилегают к корпусу планшета их повреждение в случае падения или удара далеко не редкость. В зависимости от "масштаба катастрофы" может понадобится как лечение родных динамиков, так и их замена.',
    number: "03",
  },
];

const textServiceLinkSpeaker = [
  {
    id: 1,
    title: "Возможные причины почему не работают динамики на Айпаде",
    text: (
      <>
        <RepairAppleTextWithCheckMark array={listOfTrouble} />
      </>
    ),
  },
];

const optionsIpadSpeaker = [
  { value: "iPad", label: "iPad", price: "2400" },
  { value: "iPad 2", label: "iPad 2", price: "1900" },
  { value: "iPad 3", label: "iPad 3", price: "1600" },
  { value: "iPad 4", label: "iPad 4", price: "1900" },
  { value: "iPad mini", label: "iPad mini", price: "1900" },
  { value: "iPad Air", label: "iPad Air", price: "1900" },
  { value: "iPad mini 2", label: "iPad mini 2", price: "2350" },
  { value: "iPad Air 2", label: "iPad Air 2", price: "2350" },
  { value: "iPad mini 3", label: "iPad mini 3", price: "2500" },
  { value: "iPad Pro 12.9", label: "iPad Pro 12.9", price: "1900" },
  { value: "iPad mini 4", label: "iPad mini 4", price: "2080" },
  { value: "iPad Pro 9.7", label: "iPad Pro 9.7", price: "4450" },
  { value: "iPad 5", label: "iPad 5", price: "1900" },
  { value: "iPad Pro 2 10.5", label: "iPad Pro 2 10.5", price: "1900" },
  { value: "iPad Pro 2 12.9", label: "iPad Pro 2 12.9", price: "1900" },
  { value: "iPad 6 (2018)", label: "iPad 6 (2018)", price: "1900" },
  { value: "iPad Pro 11 (2018)", label: "iPad Pro 11 (2018)", price: "1900" },
  {
    value: "iPad Pro 12.9 (2018)",
    label: "iPad Pro 12.9 (2018)",
    price: "1900",
  },
  { value: "iPad Air 3 (2019)", label: "iPad Air 3 (2019)", price: "1600" },
  { value: "iPad mini 5", label: "iPad mini 5", price: "1900" },
  { value: "iPad 7", label: "iPad 7", price: "1900" },
  { value: "iPad 8", label: "iPad 8", price: "1900" },
  { value: "iPad Air 4 (2020)", label: "iPad Air 4 (2020)", price: "1900" },
  { value: "iPad Pro 11 (2021)", label: "iPad Pro 11 (2021)", price: "1900" },
  {
    value: "iPad Pro 12.9 (2021)",
    label: "iPad Pro 12.9 (2021)",
    price: "1900",
  },
  { value: "iPad 9", label: "iPad 9", price: "1900" },
  { value: "iPad mini 6", label: "iPad mini 6", price: "1900" },
];

const RepairIpadServiceLinkSpeaker = () => {
  return (
    <Page title="Замена динамика на iPad в Москве">
      <main className="repair-iphone-group-content">
        <Helmet>
          <link
            rel="canonical"
            href="https://ohmygadget.ru/remont-apple/remont-ipad/zamena-dinamika"
          />
          <meta charSet="utf-8" />
          <meta
            name="description"
            content="Выполним быструю и квалифицированную замену динамиков на iPad в Москве и регионах РФ."
          />
        </Helmet>
        <MacProfiList />
        <BreadCrumbs />
        <RepairAppleLinksBanner
          alt="Замена динамика iPad"
          titleImg="Замена динамика iPad"
          banner={banner}
          title="Замена динамика iPad"
          text="Пропал звук на Айпаде? Скорее всего, вам понадобится замена динамиков iPad. Сделать это можно в нашем сервисном центре Мак Профи в Москве. Но сначала рекомендуем совершить несколько простых действий, дабы убедится, что проблема именно в динамиках, да и вообще действительно есть. Во-первых, проверьте - не находится ли ваш Айпад в бесшумном режиме и не находится ли звук на минимуме. Казалось бы, действия простые, но иногда о них можно и забыть, истратив немало своих нервных клеток совершенно понапрасну. Во-вторых, не лишним будет также перезагрузить планшет, выйти и снова зайти в iTunes. Если после этих действий проблемы со звуком больше никак себя не проявляют - можно о них забыть. Если появляются вновь позже - ремонта всё равно не избежать, но вам понадобится не замена динамика на айпад, а, скорее всего, перепрошивка - проблема, по-видимому, в программной части. Так или иначе, но необходима диагностика, которую, опять же, можно сделать у нас, да и ещё совершенно бесплатно. Вы сделали всё выше перечисленное, а проблемы со звуком (к слову, помимо его полной пропажи тревожными симптомами являются: различные помехи в воспроизведении, шумы и трески, перебои и захлёбывания) не куда не делись? Тогда наверняка проблема в динамиках."
        />
        <Section
          className="section_group"
          style={{
            backgroundColor: "rgba(196, 196, 196, 0.09)",
            width: "100%",
            padding: "55px 0 105px",
            marginTop: 55,
          }}
        >
          <div className="repair-mb__group-list-container">
            <h2 className="repair-mb__group-links-subtitle">
              Цена замены динамика iPad
            </h2>
            <SelectForIphoneServiceLinks
              options={optionsIpadSpeaker}
              text="динамика"
            />
          </div>
        </Section>
        <Section className="section_group" style={{ padding: "50px 0 65px" }}>
          {textServiceLinkSpeaker.map((item) => {
            return <RepairAppleLinksText key={item.id} {...item} />;
          })}
        </Section>
        <RepairIpadModelLinks />
        <RepairIpadServiceLinks />
      </main>
    </Page>
  );
};

export default RepairIpadServiceLinkSpeaker;
